/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */
import {mat4, vec3, vec4} from "gl-matrix";

export let pgcInverseMvp: mat4 = mat4.create();
export let pgcInputvector: vec4 = vec4.create();

export function unProject(aOut: vec3, aWinX: number, aWinY: number, aWinZ: number, aModelProj: mat4, aViewPort: number[])
{
    let inp = pgcInputvector;

    // aWinz -> 0 near plane
    // aWinz -> 1 far plane
    if (aWinZ === 0) {
        aWinZ = 0.00000001; // whe the depth value is zero, the we use a really small value instad
    }

    vec4.set(inp, aWinX, aWinY, aWinZ, 1.0);

    // Map x and y from window coordinates
    inp[0] = (inp[0] - aViewPort[0]) / aViewPort[2];
    inp[1] = (inp[1] - aViewPort[1]) / aViewPort[3];

    // Map to range -1 to 1
    inp[0] = (inp[0] * 2.0) - 1.0;
    inp[1] = (inp[1] * 2.0) - 1.0;
    inp[2] = (inp[2] * 2.0) - 1.0;

    mat4.invert(pgcInverseMvp, aModelProj);
    vec4.transformMat4(inp, inp, pgcInverseMvp);

    if (inp[3] === 0.0) {
        vec3.set(aOut, 0.0, 0.0, 0.0);
        return;
    }

    aOut[0] = inp[0] / inp[3];
    aOut[1] = inp[1] / inp[3];
    aOut[2] = inp[2] / inp[3];
}

/**
 *
 * @param {vec4}        aOut
 * @param {vec3}        aPoint
 * @param {mat4}        aModelProj
 * @param {[number]}    aView      [offsetX, offsetY, width, height]
 * @return {vec4}
 */
export function project(aOut: vec4, aPoint: vec3, aModelProj: mat4, aView: number[]): void
{
    let inp = vec4.fromValues(aPoint[0], aPoint[1], aPoint[2], 1.0);

    vec4.transformMat4(aOut, inp, aModelProj);

    aOut[0] /= aOut[3];
    aOut[1] /= aOut[3];
    aOut[2] /= aOut[3];

    aOut[0] = (aOut[0] * 0.5 + 0.5);
    aOut[1] = (aOut[1] * 0.5 + 0.5);
    aOut[2] = (aOut[2] * 0.5 + 0.5);

    // Map x and y from window coordinates
    aOut[0] = aOut[0] * aView[2] + aView[0];
    aOut[1] = aOut[1] * aView[3] + aView[1];
}
